export default "__VITE_ASSET__Dod3KG2G__"